import {
  COMPLETE_BATCH_REQUEST,
  COMPLETE_BATCH_SUCCESS,
  COMPLETE_BATCH_FAILURE,
  GET_BATCH_REQUEST,
  GET_BATCH_SUCCESS,
  GET_BATCH_FAILURE,
  GET_BATCHES_REQUEST,
  GET_BATCHES_SUCCESS,
  GET_BATCHES_FAILURE,
  SEARCH_BATCHES_REQUEST,
  SEARCH_BATCHES_SUCCESS,
  SEARCH_BATCHES_FAILURE,
  OPEN_DELETE_BATCH_MODAL,
  CLOSE_DELETE_BATCH_MODAL,
  DELETE_BATCH_FAILURE,
  DELETE_BATCH_SUCCESS,
  DELETE_BATCH_REQUEST
} from 'actions';

/**
 * The batches reducer
 */
function batches(state = {
  isGettingBatches: false,
  batches: [],
  batchesCount: 0,
  filteredValues: [],
  isDeleteBatchModalShown: false,
  batchToDelete: null,
  deleteBatchResponse: null,
  deleteBatchError: null,
  isDeletingBatch: false
}, action) {
  switch (action.type) {
    case COMPLETE_BATCH_REQUEST:
      return {
        ...state,
        isCompletingBatch: action.isCompletingBatch,
      };
    case COMPLETE_BATCH_SUCCESS:
      return {
        ...state,
        isCompletingBatch: action.isCompletingBatch,
        success: action.success
      };
    case COMPLETE_BATCH_FAILURE:
      return {
        ...state,
        isCompletingBatch: action.isCompletingBatch,
      };
    case GET_BATCH_REQUEST:
      return {
        ...state,
        isGettingBatch: action.isGettingBatch,
      };
    case GET_BATCH_SUCCESS:
      return {
        ...state,
        isGettingBatch: action.isGettingBatch,
        batchItem: action.batchItem
      };
    case GET_BATCH_FAILURE:
      return {
        ...state,
        isGettingBatch: action.isGettingBatch,
      };
    case GET_BATCHES_REQUEST:
      return {
        ...state,
        isGettingBatches: action.isGettingBatches
      };
    case GET_BATCHES_SUCCESS:
      return {
        ...state,
        isGettingBatches: action.isGettingBatches,
        batches: action.batches,
        batchesCount: action.batchesCount
      };
    case GET_BATCHES_FAILURE:
      return {
        ...state,
        isGettingBatches: action.isGettingBatches,
        getBatchesError: action.getBatchesError
      };
    case SEARCH_BATCHES_REQUEST:
      return {
        ...state,
        isGettingBatches: action.isGettingBatches
      };
    case SEARCH_BATCHES_SUCCESS:
      return {
        ...state,
        isGettingBatches: action.isGettingBatches,
        batches: action.batches,
        batchesCount: action.batchesCount
      };
    case SEARCH_BATCHES_FAILURE:
      return {
        ...state,
        isGettingBatches: action.isGettingBatches,
        getBatchesError: action.getBatchesError
      };
    case OPEN_DELETE_BATCH_MODAL:
      return {
        ...state,
        isDeleteBatchModalShown: action.isDeleteBatchModalShown,
        batchToDelete: action.batchToDelete
      };

    case CLOSE_DELETE_BATCH_MODAL:
      return {
        ...state,
        isDeleteBatchModalShown: action.isDeleteBatchModalShown,
        deleteBatchResponse: action.deleteBatchResponse,
        deleteBatchError: action.deleteBatchError
      };

    case DELETE_BATCH_REQUEST:
      return {
        ...state,
        isDeletingBatch: action.isDeletingBatch
      };

    case DELETE_BATCH_FAILURE:
      return {
        ...state,
        isDeletingBatch: action.isDeletingBatch
      };

    case DELETE_BATCH_SUCCESS:
      return {
        ...state,
        isDeletingBatch: action.isDeletingBatch,
        deleteBatchResponse: action.deleteBatchResponse
      };

    default:
      return state;
  }
}

export default batches;
